<template>
  <section class="seo-section">
    <h2>{{ heading }}</h2>
    <p>{{ intro }}</p>
    <div class="seo-grid">
      <router-link
        v-for="page in pages"
        :key="page.slug"
        class="seo-card seo-card-link"
        :to="page.path"
      >
        <h3>{{ page.title }}</h3>
        <p>{{ page.blurb }}</p>
        <span class="seo-card-cta">{{ page.cta }}</span>
      </router-link>
    </div>
  </section>
</template>

<script>
import { relatedPages } from '../utils/seoPages';

export default {
  name: 'SeoRelatedTools',
  props: {
    // Slug of the page rendering this block, so it never links to itself.
    currentSlug: { type: String, default: '' },
    heading: { type: String, default: 'More Steam Tools' },
    intro: {
      type: String,
      default: 'Every steamplayti.me tool reads the same Steam profile — pick whichever question you came with.',
    },
    limit: { type: Number, default: 3 },
  },
  computed: {
    pages() {
      return relatedPages(this.currentSlug, this.limit);
    },
  },
};
</script>

<style scoped>
/* Inherits .seo-section / .seo-grid / .seo-card from styles/seo-page.css so
   this block is visually identical to the cards already on these pages; the
   only additions are the affordances a card needs once it is a link. */
.seo-card-link {
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.seo-card-link:hover {
  transform: translateY(-2px);
  border-color: var(--primary);
}

.seo-card-cta {
  margin-top: auto;
  color: var(--primary);
  font-weight: 600;
}
</style>
